<template>
  <v-card elevation="0" v-if="!loading" class="w-100" ref="main-card">
    <div class="mt-4">
      <loadingProgress :loading="data_loading" />
    </div>
    <!-- <div class="fixed-header-table"></div> -->
    <v-data-table
      class="simpleTable sticky-header-table"
      :headers="headers"
      :height="600"
      :items="data"
      :items-per-page="15"
      :options.sync="pagination"
      :server-items-length="data_total"
      light
      :footer-props="{
        itemsPerPageOptions: [15, 25, 50],
        showFirstLastPage: true,
      }"
      :no-data-text="favorite_page ? 'No favorites products available' : 'No data available'"
      @update:options="sortTable"
      @update:items-per-page="setItemPerPage"
      multi-sort
      :item-class="notFound"
    >
      <template v-for="key in headers" v-slot:[`header.${key.value}`]="{ header: TableHeader }">
        <v-tooltip bottom color="primary" v-bind:key="key.value">
          <template v-slot:activator="{ on, attrs }">
            <v-row class="sm-text sm-text text-truncate" v-bind="attrs" v-on="on">
              <v-col cols="5" class="px-2 mr-2" max-width="80px">
                {{ TableHeader.text }}
              </v-col>
            </v-row>
            <!-- <v-chip v-if="getWebsiteProductsCount(TableHeader.text)" color="primary" small>{{
              getWebsiteProductsCount(TableHeader.text)
            }}</v-chip> -->
          </template>
          <div>
            <v-row>
              <v-col class="pa-auto my-auto" v-if="getWebsiteProductsCount(TableHeader.text)">
                <v-img
                  v-if="getWebsiteProductsCount(TableHeader.text)"
                  :src="`https://www.google.com/s2/favicons?domain=${TableHeader.text}`"
                  alt="Favicon"
                  width="15"
                  height="15"
                />
              </v-col>
              <v-col class="px-1">
                <div>
                  {{ TableHeader.text }}
                </div>
                <div v-if="getWebsiteProductsCount(TableHeader.text)">
                  <v-chip color="primary" x-small>
                    {{ getWebsiteProductsCount(TableHeader.text) }} products
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-tooltip>
      </template>
      <template v-slot:header.select v-if="allowMultiSelect()">
        <v-btn icon @click="selectAll()">
          <v-icon color="error" size="medium" v-if="selectedMatchs.length"
            >mdi-checkbox-marked</v-icon
          >
          <v-icon color="grey" size="medium" v-else>mdi-checkbox-blank-outline</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.select="{ item }" v-if="allowMultiSelect()">
        <v-row>
          <v-col cols="6">
            <div class="d-flex">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="align-self-center mr-2"
                    icon
                    :color="item.select ? 'error' : 'grey'"
                    @click.stop="selectMatch(item)"
                  >
                    <v-icon v-if="!item.select" :key="tableComponentKey" size="medium"
                      >mdi-checkbox-blank-outline</v-icon
                    >
                    <v-icon v-if="item.select" :key="tableComponentKey" size="medium"
                      >mdi-checkbox-marked</v-icon
                    >
                  </v-btn>
                </template>
                <span>remove thid product from favorite products</span>
              </v-tooltip>
              <div class="w-100 d-flex justify-center" v-if="item[`product_image`]">
                <img
                  @click.stop="showPriceChart(item)"
                  class="product-image cursor-pointer"
                  :src="buildImageSrc(item[`product_image`])"
                  @error="getCompetitorImage($event, item)"
                />
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div
              class="sm-text text--secondary font-weight-bold"
              v-if="account != '654b792b2071861acbbc3331'"
            >
              {{ item.match_user_ref || '' }}
            </div>
            <div class="sm-text text--secondary font-weight-bold" v-else>
              {{ item.product_ean || '' }}
            </div>
            <span v-if="item.verified">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    x-small
                    color="grey"
                    class="mr-2"
                    @click.stop="showValidateModal(item)"
                    :disabled="isViewer"
                  >
                    <v-icon color="success">mdi-check-decagram</v-icon>
                  </v-btn>
                </template>
                <span>Product match confirmed</span>
              </v-tooltip>
            </span>
            <span v-if="!item.verified">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    x-small
                    color="grey"
                    class="mr-1"
                    @click.stop="showValidateModal(item)"
                    :disabled="isViewer"
                  >
                    <v-icon color="warning">mdi-alert-circle-check-outline</v-icon>
                  </v-btn>
                </template>
                <span>Confirm product match</span>
              </v-tooltip>
            </span>
            <span v-if="item.model">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon small color="grey" class="mr-1">
                    <span class="text--disabled font-weight-bold">M</span>
                  </v-btn>
                </template>
                <span>MPN code available</span>
              </v-tooltip>
            </span>
            <!--<span v-if="item.product_ean">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon small color="grey" class="mr-1">
                <span class="text--disabled font-weight-bold">E</span>
              </v-btn>
            </template>
            <span>EAN code available {{ item.product_ean }}</span>
          </v-tooltip>
        </span>-->
            <span v-if="item.product_ean">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    color="grey"
                    class="mr-1"
                    @click="copyToClipboard(item.product_ean)"
                    @mouseenter="hoverEanItem = item.match_ref"
                    @mouseleave="hoverEanItem = null"
                  >
                    <v-icon v-if="hoverEanItem === item.match_ref" small>mdi-content-copy</v-icon>
                    <span v-else class="text--disabled font-weight-bold">E</span>
                  </v-btn>
                </template>
                <span>EAN code available {{ item.product_ean }}</span>
              </v-tooltip>
            </span>
            <span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    color="grey"
                    class="mr-1"
                    @click.stop="showPriceChart(item)"
                  >
                    <v-icon x-small>mdi-chart-line</v-icon>
                  </v-btn>
                </template>
                <span>Show changes history</span>
              </v-tooltip>
            </span>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.favorite="{ item }">
        <div class="d-flex">
          <v-tooltip bottom v-if="favorite_page">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="align-self-center mr-2"
                icon
                color="error"
                @click.stop="removeFavorite(item)"
              >
                <v-icon>$heart_off</v-icon>
              </v-btn>
            </template>
            <span>remove thid product from favorite products</span>
          </v-tooltip>
          <div class="w-100 d-flex justify-center" v-if="item[`product_image`]">
            <img
              class="product-image"
              :src="buildImageSrc(item[`product_image`])"
              @error="getCompetitorImage($event, item)"
            />
          </div>
        </div>
      </template>
      <template v-slot:item.match_user_ref="{ item }"> </template>
      <template v-slot:item.product_name="{ item }">
        <div @click.stop="showPriceChart(item)" class="more-info product-name-container">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                class="sm-text text--secondary font-weight-bold text-truncate"
                :data-match-id="item['match_id']"
                style="max-width: 280px"
                v-on="on"
                v-bind="attrs"
              >
                <!-- {{ cutText(item['product_name'], 30) }} -->
                {{ item['product_name'] }}
              </div>
            </template>
            <span>{{ item['product_name'] }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="sm-text text-truncate" style="max-width: 280px">
                {{ cutText(item.product_brand, 50) }}
              </div>
            </template>
            <span>{{ item.product_brand }}</span>
          </v-tooltip>
        </div>
        <div v-if="item.product_meta.specifications?.length">
          <v-chip
            v-for="(spec, index) in item.product_meta.specifications"
            :key="index"
            x-small
            class="default pa-2 mr-1"
          >
            {{ spec.value }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.price="{ item }">
        <span
          class="sm-text"
          v-html="
            simplePriceFormatter(item[user_website.alias], item.hight_price, item.low_price, false)
          "
        ></span>
      </template>
      <template v-slot:item.price_index="{ item }">
        <span class="text--disabled font-weight-bold sm-text">{{ item.price_index }} %</span>
      </template>
      <template v-slot:item.hight_price="{ item }">
        <v-row>
          <v-col class="" cols="12">
            <span
              class="text-danger font-weight-bold text-small sm-text"
              v-html="singlePriceHandler(item.hight_price)"
            >
            </span>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.low_price="{ item }">
        <v-row>
          <v-col class="" cols="12">
            <span
              class="text-success font-weight-bold text-small sm-text"
              v-html="singlePriceHandler(item.low_price)"
            >
            </span>
          </v-col>
        </v-row>
      </template>
      <template v-for="(key, i) in availableWebsites" v-slot:[`item.${key}`]="{ item }">
        <v-row v-bind:key="`${key}-${i}`" class="pa-0">
          <v-col cols="12">
            <div class="" v-if="!item[key]"></div>
            <a v-if="item[key]" :href="item[key]['url']" target="_blank">
              <tablepricedisplay :item="item[key]" :item-data="item" :key-name="key" />
              <div
                v-if="false"
                class="custom-left-border"
                :class="`${selectPriceIndexColorClass(item[key], item)} ${
                  item[key].price === 0 ? 'missingPrice' : ''
                }`"
              >
                <span
                  v-if="item[key].seller"
                  class="text--secondary font-weight-bold"
                  style="font-size: 0.7em"
                >
                  <!-- tooltip here-->
                  <span class="tooltip" style="z-index: 99999">
                    <v-icon size="small" class="mb-1 mr-1">mdi-storefront</v-icon>
                    <span class="tooltiptext pa-2">Seller: {{ item[key].seller }}</span>
                  </span>
                </span>
                <span
                  v-html="formatProductOffer(item[key], item, key)"
                  :class="selectPriceColorClass(item[key], item)"
                ></span>
                <!--In case the seller is -->
              </div>
            </a>
          </v-col>
        </v-row>
      </template>
      <!-- Google Shopping column header -->
      <template v-slot:header._google_shopping>
        <div class="d-flex align-center sm-text">
          <v-img
            src="https://www.google.com/s2/favicons?domain=shopping.google.com"
            width="14"
            height="14"
            contain
            class="mr-0"
          />
          <span>Google Shopping</span>
        </div>
      </template>

      <!-- Google Shopping consolidated column -->
      <template v-slot:item._google_shopping="{ item }">
        <v-row>
          <v-col cols="12" class="pa-1">
            <div
              v-if="item._google_shopping && item._google_shopping.minOffer"
              style="cursor: pointer"
              @click.stop="openGoogleShoppingDialog(item)"
            >
              <tablepricedisplay :item="item._google_shopping.minOffer" />
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.menu="{ item }">
        <v-menu open-on-hover auto>
          <template v-slot:activator="{ on: menu }" class="pa-4">
            <v-btn class="action-icon" v-on="{ ...menu }" medium icon>
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-card class="pa-0" flat>
            <v-card-text>
              <v-row>
                <v-col :cols="isViewer ? 6 : 3" class="pa-1">
                  <v-btn small icon>
                    <v-icon size="medium" @click.stop="showPriceChart(item)">$eye_outline</v-icon>
                  </v-btn>
                </v-col>
                <v-divider vertical v-if="!isViewer"></v-divider>
                <v-col cols="3" class="pa-1" v-if="!isViewer">
                  <v-btn small icon>
                    <v-icon size="medium" @click.stop="confirmDelete(item)">$delete</v-icon>
                  </v-btn>
                </v-col>
                <v-divider vertical v-if="!isViewer"></v-divider>
                <v-col cols="3" class="pa-1" v-if="!isViewer">
                  <v-btn small icon>
                    <v-icon size="medium" @click.stop="showEditModal(item)">$edit</v-icon>
                  </v-btn>
                </v-col>
                <v-divider vertical></v-divider>
                <v-col :cols="isViewer ? 6 : 3" class="pa-1">
                  <v-btn small icon>
                    <v-icon
                      size="medium"
                      :color="item.favorite ? 'error' : 'grey'"
                      @click.stop="setFavorite(item)"
                      >$heart</v-icon
                    >
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-menu>
      </template>
    </v-data-table>

    <!-- Google Shopping offers detail dialog -->
    <v-dialog v-model="googleShoppingDialog" max-width="940" scrollable>
      <v-card v-if="googleShoppingDialogItem">
        <!-- Title — matches editMatchModal / deleteModal pattern -->
        <v-card-title>
          <v-icon class="mr-2">mdi-google</v-icon>
          <span class="md-text">Google Shopping Offers</span>
          <v-btn icon class="ml-auto" @click="googleShoppingDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Product info -->
        <div class="px-4 pb-2 pt-0">
          <div class="font-weight-bold">{{ googleShoppingDialogItem.product_name }}</div>
          <div class="sm-text text--secondary" v-if="googleShoppingDialogItem.product_brand">
            {{ googleShoppingDialogItem.product_brand }}
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Summary strip -->
        <div class="px-4 py-2 d-flex align-center flex-wrap" style="gap: 8px; background: #f5f5f5">
          <!-- My price -->
          <span
            class="sm-text text--secondary"
            v-if="
              googleShoppingDialogItem['_' + user_website.alias] &&
              googleShoppingDialogItem['_' + user_website.alias].price > 0
            "
          >
            <span class="font-weight-bold primary--text mr-1">My price:</span>
            {{ gsFormatPrice(googleShoppingDialogItem['_' + user_website.alias].price) }}
          </span>

          <!-- Offers count -->
          <span class="sm-text text--secondary">
            <span class="font-weight-bold mr-1">Offers:</span
            >{{ googleShoppingDialogItem._google_shopping.allOffers.length }}
          </span>

          <!-- Best / Highest -->
          <span class="sm-text text--secondary">
            <span class="font-weight-bold success--text mr-1">Best:</span>
            {{
              gsFormatPrice(
                googleShoppingDialogItem._google_shopping.allOffers.filter((o) => o.price > 0)[0] &&
                  googleShoppingDialogItem._google_shopping.allOffers.filter((o) => o.price > 0)[0]
                    .price,
              )
            }}
          </span>
          <span class="sm-text text--secondary">
            <span class="font-weight-bold error--text mr-1">Highest:</span>
            {{
              gsFormatPrice(
                googleShoppingDialogItem._google_shopping.allOffers
                  .slice()
                  .reverse()
                  .find((o) => o.price > 0) &&
                  googleShoppingDialogItem._google_shopping.allOffers
                    .slice()
                    .reverse()
                    .find((o) => o.price > 0).price,
              )
            }}
          </span>
          <v-spacer></v-spacer>
          <span class="sm-text text--disabled">Sorted by price ↑</span>
        </div>

        <v-divider></v-divider>

        <!-- Column header row — sm-text like the data-table headers -->
        <div
          class="px-4 py-2 d-flex align-center sm-text text--secondary font-weight-bold"
          style="background: #fafafa"
        >
          <div style="width: 36px"></div>
          <div style="flex: 1">Store</div>
          <div style="width: 120px">Price</div>
          <div style="width: 80px">Index</div>
          <div style="width: 90px">Status</div>
          <div style="width: 100px">Updated</div>
          <div style="width: 36px"></div>
        </div>

        <v-divider></v-divider>

        <!-- Offers list -->
        <v-card-text class="pa-0 gs-offers-list">
          <template v-for="(offer, i) in googleShoppingDialogItem._google_shopping.allOffers">
            <a
              :key="i"
              :href="offer.url"
              target="_blank"
              class="gs-offer-row d-flex align-center px-4 py-4"
              :class="{ 'gs-offer-best': i === 0 && offer.price > 0 }"
            >
              <!-- Favicon -->
              <div style="width: 36px" class="d-flex align-center">
                <v-img
                  :src="`https://www.google.com/s2/favicons?domain=${offer.websiteAlias}`"
                  width="16"
                  height="16"
                  contain
                />
              </div>

              <!-- Store + seller -->
              <div style="flex: 1; min-width: 0" class="pr-3">
                <div class="sm-text font-weight-bold text-truncate">{{ offer.websiteAlias }}</div>
                <div v-if="offer.seller" class="sm-text text--secondary text-truncate">
                  <v-icon x-small class="mr-1">mdi-storefront</v-icon>{{ offer.seller }}
                </div>
              </div>

              <!-- Price -->
              <div style="width: 120px">
                <span
                  v-if="offer.price > 0"
                  class="sm-text font-weight-bold"
                  :class="i === 0 ? 'success--text' : ''"
                  >{{ gsFormatPrice(offer.price) }}</span
                >
                <span v-else class="sm-text text--disabled font-italic">Pending</span>
              </div>

              <!-- Price index -->
              <div style="width: 80px">
                <span
                  v-if="
                    offer.priceIndex !== undefined && offer.priceIndex !== null && offer.price > 0
                  "
                  class="sm-text font-weight-bold"
                  :class="
                    offer.priceIndex > 0
                      ? 'error--text'
                      : offer.priceIndex === 0
                      ? 'warning--text'
                      : 'success--text'
                  "
                  >{{ offer.priceIndex > 0 ? '+' : '' }}{{ offer.priceIndex.toFixed(2) }}%</span
                >
                <span v-else class="sm-text text--disabled">—</span>
              </div>

              <!-- Availability -->
              <div style="width: 90px">
                <v-chip
                  v-if="offer.availability && offer.price > 0"
                  x-small
                  :color="offer.availability.toLowerCase() === 'instock' ? 'success' : 'error'"
                  outlined
                >
                  {{ offer.availability.toLowerCase() === 'instock' ? 'In Stock' : 'Out of Stock' }}
                </v-chip>
              </div>

              <!-- Update date -->
              <div style="width: 100px">
                <span v-if="offer.updateDate" class="sm-text text--secondary">
                  {{ gsFormatDate(offer.updateDate) }}
                </span>
                <span v-else class="sm-text text--disabled">—</span>
              </div>

              <!-- External link -->
              <div style="width: 36px" class="d-flex justify-end">
                <v-icon x-small color="grey lighten-1">mdi-open-in-new</v-icon>
              </div>
            </a>
            <v-divider
              :key="`d-${i}`"
              v-if="i < googleShoppingDialogItem._google_shopping.allOffers.length - 1"
            ></v-divider>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import tablepricedisplay from './tablePriceDisplay.vue'
  import axios from 'axios'
  export default {
    name: 'simpleComparePricesTable',
    props: [
      'items',
      'filter',
      'loading',
      'favorite_page',
      'exclusive_page',
      'changed',
      'total',
      'selected_price_index',
      'component_name',
    ],
    components: {
      tablepricedisplay,
    },
    data() {
      return {
        hoverEanItem: null,
        googleShoppingDialog: false,
        googleShoppingDialogItem: null,
        account: localStorage.getItem('account_id'),
        isDevMode: false,
        tableComponentKey: 0,
        data_loading: false,
        user_website: localStorage.user_website ? JSON.parse(localStorage.user_website) : {},
        pagination: { rowsPerPage: 15, totalItems: 0 },
        searchParams: {},
        from: 0,
        size: 15,
        competitors_websites: [],
        availableWebsites: [],
        headers: [
          {
            text: 'Product',
            value: 'product_name',
            sortable: false,
            width: '300px',
          },
          {
            text: 'Price',
            value: 'price',
            align: 'left',
            width: '110px',
            sortable: false,
          },
          {
            text: 'Index %',
            value: 'price_index',
            align: 'left',
            width: '90px',
            sortable: false,
          },
          {
            text: 'Min',
            value: 'low_price',
            sortable: false,
            width: '50ps',
          },
          {
            text: 'Max',
            value: 'hight_price',
            sortable: false,
            width: '50px',
          },
        ],
        data: [],
        selectedMatchs: [],
        data_total: 0,
        matchsStats: false,
        table_sorts: [],
        price_index: null,
      }
    },
    computed: {
      isViewer() {
        return this.$store.getters.userRole === 'viewer'
      },
    },
    async mounted() {
      await this.getFilterData()
      this.isDevMode = process.env.VUE_APP_MODE === ''

      /**
       * show the current component
       */
      if (this.allowMultiSelect()) {
        this.headers.unshift({
          text: '',
          value: 'select',
          sortable: false,
          width: '300px',
        })
      }

      if (this.favorite_page) {
        this.headers.unshift({
          text: '',
          value: 'favorite',
          sortable: false,
          width: '50px',
        })
      }

      this.headers.unshift({
        text: '',
        value: 'menu',
        sortable: false,
        width: '50px',
      })

      this.fixTablsColumns()
    },
    methods: {
      getWebsiteProductsCount(websiteAlias) {
        const website = this.competitors_websites.find(
          (item) => item.competitor_website === websiteAlias,
        )
        return website ? website.count : ''
      },
      async getFilterData() {
        await axios
          .get('/api/products/getfilterdata', {
            params: {
              account: localStorage.getItem('account_id'),
              user: localStorage.getItem('user_id'),
              component: '',
            },
          })
          .then((response) => {
            this.competitors_websites = response.data.competitors_websites
            //alert(JSON.stringify(this.competitors_websites, null, 2))
          })
          .catch((error) => {
            console.error('Error fetching filter data:', error)
          })
      },
      selectPriceColorClass(offer, match) {
        if (offer.price === 0) {
          return
        }
        const offerPrice = offer.coefficientPrice || offer.price
        const matchPrice = match.product_offer.price
        const priceIndex = Math.round(((offerPrice - matchPrice) / matchPrice) * 100)

        if (priceIndex === 0) return 'equal'
        else if (priceIndex < 0) return 'higher'
        else if (priceIndex > 0) return 'lower'

        //if (priceIndex >= 0 && priceIndex < 10) return 'same'
        //else if (priceIndex >= 10 && priceIndex < 20) return 'high'
        //else if (priceIndex >= 20 && priceIndex < 50) return 'before-max'
        //else if (priceIndex >= 50) return 'max'

        //if (priceIndex < 0 && priceIndex > -10) return 'same'
        //else if (priceIndex <= -10 && priceIndex > -20) return 'high'
        //else if (priceIndex <= -20 && priceIndex > -50) return 'before-max'
        //else if (priceIndex <= -50) return 'min'
      },
      selectPriceIndexColorClass(offer, match) {
        if (offer.price === 0) {
          return
        }
        const offerPrice = offer.coefficientPrice || offer.price
        const matchPrice = match.product_offer.price
        const priceIndex = Math.round(((offerPrice - matchPrice) / matchPrice) * 100)

        if (priceIndex == 0) return 'equal-border'
        else if (priceIndex < 0) return 'higher-border'
        else if (priceIndex > 0) return 'lower-border'
        else {
          return 'neutral-border'
        }

        //if (priceIndex >= 0 && priceIndex < 10) return 'same-border'
        //else if (priceIndex >= 10 && priceIndex < 20) return 'high-border'
        //else if (priceIndex >= 20 && priceIndex < 50) return 'before-max-border'
        //else if (priceIndex >= 50) return 'max-border'

        //if (priceIndex < 0 && priceIndex > -10) return 'same-border'
        //else if (priceIndex <= -10 && priceIndex > -20) return 'high-border'
        //else if (priceIndex <= -20 && priceIndex > -50) return 'before-max-border'
        //else if (priceIndex <= -50) return 'min-border'

        //if (priceIndex > 50) return 'max'
        //if (priceIndex >= 20 && priceIndex <= 50) return 'heigh'
        //if (priceIndex >= 0 && priceIndex < 20) return 'same'
        //if (priceIndex <= -20 && priceIndex > -50) return 'low'
        //if (priceIndex <= -50) return 'min'

        //if (priceIndex < -10) return 'max'
        //if (priceIndex >= -10 && priceIndex < 0) return 'heigh'
        //if (priceIndex >= 0 && priceIndex < 10) return 'same'
        //if (priceIndex >= 10 && priceIndex < 20) return 'low'
        //if (priceIndex >= 20) return 'min'
      },
      copyToClipboard(text) {
        navigator.clipboard.writeText(text).catch((err) => {
          console.error('Failed to copy text: ', err)
        })
      },
      fixTablsColumns() {
        var table = document.getElementsByTagName('table')[0]
        var thCells = table.querySelectorAll('thead th')
        var fixedColumns = []
        var css = ''

        // Calculate and generate CSS for fixing columns
        var leftPosition = 0
        for (var i = 0; i < thCells.length; i++) {
          if (i < 6) {
            css += '.fixed-column:nth-child(' + (i + 1) + ') { left: ' + leftPosition + 'px; }\n'
            // Apply the fixed-column class to the first six cells
            thCells[i].classList.add('fixed-column')
            fixedColumns.push(thCells[i])
          }
          leftPosition += thCells[i].offsetWidth
        }

        // Inject CSS into <style> tag
        var styleTag = document.createElement('style')
        styleTag.innerHTML = css
        document.head.appendChild(styleTag)

        // Add scroll event listener
        table.addEventListener('scroll', function () {
          var scrollTop = table.scrollTop
          var scrollLeft = table.scrollLeft

          // Apply scroll position to the fixed columns
          fixedColumns.forEach(function (column) {
            column.style.top = scrollTop + 'px'
          })

          // Apply scroll position to the header row
          var headerRow = table.querySelector('thead tr')
          headerRow.style.transform = 'translateX(-' + scrollLeft + 'px)'
        })
      },
      cutText(text, length) {
        return text.length > length ? text.substring(0, length) + '...' : text
      },
      forceUpdate() {
        this.tableComponentKey++
      },
      allowMultiSelect() {
        return ['/pricing', '/compare', '/exclusiveproducts'].includes(
          window.location.pathname.toLowerCase(),
        )
      },
      buildImageSrc(item) {
        if (item && item.match(/data:image\/.*/g)) {
          return item.match(/data:image\/.*/g)[0]
        }
        return item
      },
      openGoogleShoppingDialog(item) {
        this.googleShoppingDialogItem = item
        this.googleShoppingDialog = true
      },
      gsFormatDate(dateStr) {
        if (!dateStr) return '—'
        try {
          const d = new Date(dateStr)
          if (isNaN(d.getTime())) return dateStr
          return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
        } catch (e) {
          return dateStr
        }
      },
      gsFormatPrice(price) {
        if (price === undefined || price === null) return '—'
        let locale = 'es-ES'
        let currency = 'EUR'
        try {
          const country = this.user_website.country || 'es'
          const map = {
            mx: ['es-MX', 'MXN'],
            es: ['es-ES', 'EUR'],
            ch: ['de-CH', 'CHF'],
            uk: ['en-GB', 'GBP'],
            do: ['es-DO', 'DOP'],
          }
          if (map[country]) [locale, currency] = map[country]
        } catch (e) {
          /* fallback */
        }
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(price)
      },
      gsDiffLabel(offerPrice, myPrice) {
        const diff = Math.round(((offerPrice - myPrice) / myPrice) * 100)
        if (diff === 0) return '= equal'
        return (diff > 0 ? '+' : '') + diff + '%'
      },
      gsDiffClass(offerPrice, myPrice) {
        const diff = offerPrice - myPrice
        if (diff < 0) return 'success--text'
        if (diff === 0) return 'amber--text text--darken-2'
        return 'error--text'
      },
      confirmDelete(item) {
        this.$emit('confirm-delete', item)
      },
      showPriceChart(item) {
        this.$emit('show-price-chart', item)
      },
      showEditModal(item) {
        this.$emit('show-edit-modal', item)
      },
      showValidateModal(item) {
        console.log('show validate modal for item: ', item);
        this.$emit('show-validate-modal', {
          item,
          data: this.data,
          pagination: {
            from: this.from,
            size: this.size,
          },
          searchParams: this.searchParams,
        })
      },
      setItemPerPage(val) {
        this.pagination.rowsPerPage = val
      },
      getInvalidProductsLength(item) {
        return Object.keys(item)
          .map((key) => {
            if (item[key] && item[key].product) {
              return item[key].product
            }
          })
          .filter((product) => product && !product.validated).length
      },
      getInvalidProducts(item) {
        const invalidProducts = this.getInvalidProductsLength(item)
        return invalidProducts ? `${invalidProducts} need validation` : ''
      },
      sortTable(sorts) {
        this.table_sorts = []
        let sort_by = sorts.sortBy
        let sort_order = sorts.sortDesc
        sort_by.map((elt, index) => {
          this.table_sorts.push({
            sort_by: elt,
            order: sort_order[index] ? 'desc' : 'asc',
          })
        })
      },
      async setFavorite(item) {
        let index = this.data.indexOf(item)
        this.data[index].favorite = !this.data[index].favorite
        await axios
          .post(`/api/products/favorite`, {
            account: localStorage.getItem('account_id'),
            user: localStorage.getItem('user_id'),
            component: this.component_name,
            id_match: item.match_id,
            favorite: this.data[index].favorite,
          })
          .then((res) => {
            if (res.data.status) {
              if (res.data.operation)
                this.$emit('show-notification', {
                  msg: `the product named ( ${this.data[index].product_name} ) has been successfully added to favorites, check your favorites list`,
                  type: 'success',
                  icon: 'heart',
                })
              else
                this.$emit('show-notification', {
                  msg: `the product named ( ${this.data[index].product_name} ) has been successfully removed from favorites, check your favorites list`,
                  type: 'error',
                  icon: 'heart-off',
                })
            }
          })
      },
      async getProducts() {
        //let filter = this.filter != undefined ? this.filter : {}
        //console.log('filter from propr : ', filter)
        let filter = localStorage.getItem('filter')
          ? JSON.parse(localStorage.getItem('filter'))
          : { source: '' }
        this.headers = this.headers.slice(0, 8)
        this.data = []
        this.data_loading = true
        this.from = this.pagination.page * this.pagination.rowsPerPage - this.pagination.rowsPerPage
        this.size = this.pagination.rowsPerPage

        if (!filter.source) filter.source = ''

        /**
         * If the price index is selected from the distrubution chart let's fetch only validated products in the table
         */
        if (this.price_index != null) {
          filter.matched = 'Validated'
        }

        this.searchParams = {
          ...filter,
          account: localStorage.getItem('account_id'),
          updateInterval: localStorage.getItem('updateInterval') || 1,
          user: localStorage.getItem('user_id'),
          table_sorts: this.table_sorts,
          favorite_only: this.favorite_page,
          exclusive_only: this.exclusive_page,
          price_index: this.price_index,
          component: this.component_name,
          raw_price_index: filter.price_index,
          page: this.pagination.page,
          rowsPerPage: this.pagination.rowsPerPage,
          from: this.from,
          size: this.size,
        }

        if (this.searchParams.key) {
          this.searchParams.page = 1
          this.searchParams.from = 0
        }

        this.data = await axios
          .get('/api/products/list', {
            params: {
              ...this.searchParams,
            },
          })
          .then((res) => {
            if (res) {
              this.data_total = res.data.total
              this.addCompetitorsItems(res.data.data)
              return res.data.data
            }
            return []
          })
          .catch((err) => {
            console.log(err)
            console.error('comparePricesTable - getProducts')
            return []
          })
        this.data_loading = false
        this.selectedMatchs = []
      },
      async selectAll() {
        if (this.selectedMatchs.length > 0) {
          this.selectedMatchs = []
          for (const elt of this.data) {
            elt.select = false
          }
        } else {
          for (const elt of this.data) {
            elt.select = true
            this.selectedMatchs.push(elt)
          }
        }
        this.forceUpdate()
        this.$emit('select-matchs', this.selectedMatchs)
      },
      async selectMatch(item) {
        item.select = !item.select
        if (item.select) {
          this.selectedMatchs.push(item)
        } else {
          this.selectedMatchs = this.selectedMatchs.filter((elt) => elt.match_id != item.match_id)
        }
        this.$emit('select-matchs', this.selectedMatchs)
      },
      async removeFavorite(item) {
        this.$emit('confirm-unfavorite', item)
      },
      getCompetitorImage(e, match) {
        let image = ''
        const website = Object.keys(match).find(
          (key) => match[key].product && match[key].product.image && match[key].product.validated,
        )
        if (website) image = match[website].product.image
        e.target.src = image
      },
      addCompetitorsItems(data) {
        let filterWithThisWebsite = []

        if (
          this.filter &&
          this.filter.competitors_websites &&
          this.filter.competitors_websites.length
        ) {
          filterWithThisWebsite = this.filter.competitors_websites
        }

        let websitesHeaders = []
        let hasGoogleShoppingProducts = false
        const gsWebsiteAliases = new Set()

        data.forEach((datum) => {
          let gsOffers = []

          Object.entries(datum).forEach(([key, value]) => {
            if (value && typeof value == 'object') {
              if (value.product) {
                if (value.product.isGoogleShoppingProduct) {
                  // Aggregate all Google Shopping offers into a single column
                  gsWebsiteAliases.add(key)
                  const offers =
                    value.product.offers && value.product.offers.length ? value.product.offers : []
                  offers.forEach((offer) => {
                    gsOffers.push({
                      ...offer,
                      url: value.product.url,
                      websiteAlias: key,
                      isGoogleShoppingProduct: true,
                    })
                  })
                  hasGoogleShoppingProducts = true
                } else {
                  // Direct crawl: keep one column per website (original behaviour)
                  datum[`_${key}`] = value.product.offers.length ? value.product.offers[0] : {}
                  datum[`_${key}`]['url'] = value.product.url
                  datum[`_${key}`]['isGoogleShoppingProduct'] =
                    value.product.isGoogleShoppingProduct
                  if (!websitesHeaders.find((header) => header.value == `_${key}`)) {
                    if (filterWithThisWebsite.length) {
                      if (filterWithThisWebsite.includes(key)) {
                        if (key != this.user_website.alias) {
                          this.availableWebsites.push(`_${key}`)
                          websitesHeaders.push({
                            text: `${key}`,
                            value: `_${key}`,
                            sortable: false,
                            width: '110px',
                            class: 'pa-1',
                            align: 'left',
                          })
                        }
                      }
                    } else {
                      if (key != this.user_website.alias) {
                        this.availableWebsites.push(`_${key}`)
                        websitesHeaders.push({
                          text: `${key}`,
                          value: `_${key}`,
                          sortable: false,
                          width: '110px',
                          class: 'pa-1',
                          align: 'left',
                        })
                      }
                    }
                  }
                }
              }
            }
          })

          // Build the consolidated Google Shopping entry for this row
          if (gsOffers.length) {
            const validOffers = gsOffers.filter((o) => o.price > 0)
            const minOffer = validOffers.length
              ? validOffers.reduce((min, o) => (o.price < min.price ? o : min), validOffers[0])
              : gsOffers[0]
            datum._google_shopping = {
              minOffer,
              allOffers: gsOffers.slice().sort((a, b) => a.price - b.price),
            }
          } else {
            datum._google_shopping = null
          }
        })

        //add any missing websites from the competitors_websites
        const cachedFilter = JSON.parse(localStorage.getItem('filter'))
        const filteredWebsites = cachedFilter?.competitors_websites || []
        if (!filteredWebsites.length) {
          this.competitors_websites.forEach((website) => {
            // Skip Google Shopping websites — they are merged into the single GS column
            if (gsWebsiteAliases.has(website.competitor_website)) return

            // Only filter by actual data presence when there are more than 10 competitors
            if (this.competitors_websites.length > 10) {
              const hasDataInRows = data.some(
                (datum) =>
                  datum[website.competitor_website] &&
                  datum[website.competitor_website].product &&
                  datum[website.competitor_website].product.offers &&
                  datum[website.competitor_website].product.offers.length > 0,
              )
              if (!hasDataInRows) return
            }
            if (
              !websitesHeaders.find((header) => header.value == `_${website.competitor_website}`) &&
              website.competitor_website != this.user_website.alias
            ) {
              websitesHeaders.push({
                text: website.competitor_website,
                value: `_${website.competitor_website}`,
                sortable: false,
                width: '110px',
                class: 'pa-1',
                align: 'left',
              })
            }
          })
        }

        websitesHeaders = websitesHeaders.sort((a, b) => {
          if (a.text < b.text) return -1
          if (a.text > b.text) return 1
          return 0
        })

        //unshift the default user_website alias
        if (
          !websitesHeaders.find((header) => header.value == `_${this.user_website.alias}`) &&
          (!filteredWebsites.length || filteredWebsites.includes(this.user_website.alias))
        ) {
          websitesHeaders.unshift({
            text: this.user_website.alias,
            value: `_${this.user_website.alias}`,
            sortable: false,
            width: '110px',
            class: 'pa-1',
            align: 'left',
          })
          if (!this.availableWebsites.includes(`_${this.user_website.alias}`)) {
            this.availableWebsites.push(`_${this.user_website.alias}`)
          }
        }

        // Append a single Google Shopping column at the end if any GS products were found
        if (
          hasGoogleShoppingProducts &&
          !websitesHeaders.find((h) => h.value === '_google_shopping')
        ) {
          websitesHeaders.push({
            text: 'Google Shopping',
            value: '_google_shopping',
            sortable: false,
            width: '180px',
            class: 'pa-1',
            align: 'left',
          })
        }

        if (websitesHeaders.length) {
          this.headers = this.headers.slice(0, 7)
          this.headers = this.headers.concat(websitesHeaders)
        }
      },
      notFound(item) {
        if (item[this.user_website.alias] && item[this.user_website.alias].product.not_found)
          return 'not_found_product'
      },
    },
    watch: {
      filter: {
        handler() {
          if (this.pagination.page === 1) {
            this.getProducts()
          } else {
            this.pagination.page = 1
          }
        },
        deep: true,
      },
      selectedMatchs: {
        handler() {},
      },
      pagination: {
        handler(newV, old) {
          try {
            this.getProducts().finally(() => {
              if (newV.page && old.page && newV.page != old.page) {
                this.$refs['main-card'].$el.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                })
              }
            })
          } catch (error) {
            console.log('pagination', error)
          }
        },
        deep: true,
      },
      changed: {
        deep: true,
        async handler() {
          this.price_index = undefined
          await this.getProducts()
        },
      },
      selected_price_index: {
        handler() {
          this.price_index = this.selected_price_index
          this.getProducts()
        },
      },
      total: {
        handler() {
          this.data_total = this.total
        },
      },
    },
  }
</script>
<style scoped>
  .product-image {
    object-fit: contain;
    max-width: 100;
    max-height: 50px;
    background-size: cover;
  }
  .more-info {
    cursor: pointer;
  }
  .product-name-container {
    max-width: 280px;
    overflow: hidden;
  }
  .brand-text {
    font-size: 1rem;
    font-weight: 600;
  }
  .product-name-text {
    font-size: 1.2rem;
  }
  /* Google Shopping Dialog */
  .gs-offers-list {
    max-height: 480px;
    overflow-y: auto;
  }
  .gs-offer-row {
    display: flex;
    text-decoration: none;
    color: inherit;
    transition: background 0.15s ease;
  }
  .gs-offer-row:hover {
    background: #f5f5f5;
  }
  .gs-offer-best {
    border-left: 3px solid #42b983;
    padding-left: 13px !important; /* compensate for border width */
  }
</style>
<style>
  .v-menu__content {
    box-shadow: none !important;
    border: 1px solid #e0e0e0 !important;
  }

  .simpleTable thead tr th:first-child,
  .simpleTable tbody tr td:first-child {
    position: sticky !important;
    position: -webkit-sticky !important;
    left: 0;
    z-index: 1;
    background: white;
  }

  .priceIndexStyle {
    border: solid 2px;
    border-color: orange;
    border-top: none;
    border-right: none;
    border-bottom: none;
  }

  .custom-left-border {
    position: relative;
    padding-left: 10px; /* space for the pseudo-border */
  }

  .custom-left-border::before {
    content: '';
    position: absolute;
    left: 0;
    top: 10px; /* space from the top */
    bottom: 10px; /* space from the bottom */
    width: 1.5px; /* border thickness */
  }

  .higher {
    color: #ff0000; /* Emerald */
  }

  .lower {
    color: #93de80;
  }

  .equal {
    color: #f5c845; /* Light Gray */
  }

  .higher-border::before {
    background-color: #ff0000; /* Emerald */
  }
  .lower-border::before {
    background-color: #93de80;
  }
  .equal-border::before {
    background-color: #f5c845; /* Light Gray */
  }

  .neutral-border::before {
    background-color: #ff0000; /* Neutral Gray */
  }

  .missingPrice {
    opacity: 0.5;
    border-color: rgb(194, 194, 194);
    padding: 5px;
  }

  .v-data-table--fixed-header .v-data-table__wrapper {
    overflow-y: auto !important;
  }

  .sticky-header-table thead th {
    position: sticky !important;
    top: 0 !important;
    z-index: 2 !important;
    background: white !important;
  }
</style>
